<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-row>
            <b-col class="text-right">
              <router-link :to="{ name: 'EXCMTagCreate' }" class="btn btn-primary">{{ $t('buttons.create') }}</router-link>
            </b-col>
          </b-row>
          <!--<div v-if="isLoading" class="alert alert-info">{{$t('alerts.loading')}}...</div>-->
          <div v-if="deletedItem" class="alert alert-success">{{ deletedItem['name'] }} {{$t('notifications.deleted')}}</div>
          <div v-if="error" class="alert alert-danger">{{ error }}</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <!--            <div class="card-header">-->
            <!--              <h4 class="card-title">{{$t('views.exsbitemscategories.list.title')}}</h4>-->
            <!--            </div>-->
            <div class="card-body">
              <Loader v-if="isLoading" size="lg"></Loader>
              <template v-else>
                <b-row>
                  <b-col>
                    <div v-if="items.length > 0">
                      <table class="table table-sm table-striped table-hover">
                        <thead>
                        <tr>
                          <th>{{$t('views.excmtag.title')}}</th>
                          <th>{{$t('views.excmtag.consentTag')}}</th>
                          <th class="float-right ">{{$t('views.excmtag.options')}}</th>
<!--                          <th colspan="1" />-->
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in items" :key="item['@id']">
                          <td>
                            {{ item['tag']}}
                          </td>
                          <td>
                            {{ getTagCategory(item.tagType) }}
                          </td>
                          <td>
                            <router-link :to="{name: 'EXCMTagUpdate', params: { id: item['@id'] }}" class="float-right">
                              <button class="btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
                            </router-link>
                            <button class="float-right btn btn-link fa fa-trash" @click="deleteSingle(item['@id'])" v-b-tooltip.hover :title="$t('buttons.delete')" aria-hidden="true" />
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <p v-else>{{$t('views.excmtag.noTags')}}</p>
                  </b-col>
                </b-row>
                <div v-if="view">
                  <pagination
                    :view="view"
                    @getPage="getPage($event)"
                  ></pagination>
                </div>
              </template>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'
import remove from '@/utils/remove'

export default {
  components: {
    Loader,
    Pagination
  },
  data () {
    return {
      tagTypeOptions: [
        {
          text: this.$t('views.excmtag.tagOption.tagTypeOption1'),
          value: 1
        },
        {
          text: this.$t('views.excmtag.tagOption.tagTypeOption2'),
          value: 2
        },
        {
          text: this.$t('views.excmtag.tagOption.tagTypeOption3'),
          value: 3
        },
        {
          text: this.$t('views.excmtag.tagOption.tagTypeOption4'),
          value: 4
        },
        {
          text: this.$t('views.excmtag.tagOption.tagTypeOption5'),
          value: 5
        }
      ]
    }
  },
  computed: mapGetters({
    deletedItem: 'excmtag/del/deleted',
    error: 'excmtag/list/error',
    items: 'excmtag/list/items',
    isLoading: 'excmtag/list/isLoading',
    view: 'excmtag/list/view'
  }),

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMTagList')
  },

  created () {
    this.getPage()
    this.channelBusinessItemsCategories = this.$store.state.Pusher.subscribe('e_x_c_m_tags')
    this.channelBusinessItemsCategories.bind('e_x_c_m_tags', data => {
      this.getPage()
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_c_m_tags')
  },

  methods: {
    ...mapActions({
      getPage: 'excmtag/list/default'
    }),
    getTagCategory (categoryType) {
      return this.tagTypeOptions.find(option => option.value === categoryType).text
    },
    deleteSingle (id) {
      remove(id, () => {
        this.getPage()
      })
    }
  }
}
</script>
